import {
  SALESBANNER_CURRENT_SLIDE_CHANGED,
} from '../actions';

const initialState = {
};

const mergeSalesBannerState = (state, salesBannerSliceId, nextState) => ({
  ...state,
  [salesBannerSliceId]: {
    ...state[salesBannerSliceId],
    ...nextState,
  },
});

const salesbanner = (state = initialState, action) => {
  switch (action.type) {
    case SALESBANNER_CURRENT_SLIDE_CHANGED:
      return mergeSalesBannerState(state, action.payload.salesBannerSliceId, {
        slideIndex: action.payload.slideIndex,
      });

    default:
      return state;
  }
};

export default salesbanner;
